// eslint-disable-next-line no-undef
const tiktokAdDomain = TIKTOK_AD_DOMAIN;
export const commonLinkMap = {
  POLICY: {
    i18nKey: "footer_menu_terms",
    link: `${tiktokAdDomain}/i18n/official/policy/terms`,
    label: "terms"
  },
  SUPPORT: {
    i18nKey: "footer_menu_help",
    link: `${tiktokAdDomain}/help`,
    label: "help"
  },
  CONTACT: {
    i18nKey: "footer_menu_contact",
    link: `${tiktokAdDomain}/i18n/contact`,
    label: "contact"
  }
};
